import pdf from 'vue-pdf';
import closeIcon from '@/components/Icons/Modals/Close.vue';

export default {
  name: 'PdfViewer',

  props: ['route'],

  components: {
    pdf,
    closeIcon
  },

  data() {
    return {
      loader: true,

      src: null,
      numPages: 0
    }
  },

  methods: {
    closeModal() {
      this.$parent.pdfRoute = '';
    }
  },

  mounted() {
    this.src = pdf.createLoadingTask(this.route);

    this.src.promise.then(pdf => {
      this.numPages = pdf.numPages;

      this.loader = false;
    });
  }
}
